<template>
  <label :for="label" class="block text-sm font-medium mb-2 dark:text-white" v-if="label">{{ label }}</label>
  <div class="relative">
    <input type="color"
      class="p-1 h-10 w-14 block bg-white border border-gray-400 cursor-pointer rounded-lg disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700"
      v-model="model" title="Escoje un color">
    <XMarkIcon v-if="clear" @click="clearEvent ? clearEvent() : model = null;"
      class="cursor-pointer absolute shrink-0 size-6 text-sm font-semibold rounded-lg border border-transparent bg-blue-50 text-gray-500 hover:bg-blue-100 disabled:opacity-50 disabled:pointer-events-none dark:hover:bg-blue-900 dark:text-blue-400 dark:focus:outline-none dark:focus:ring-1 dark:focus:ring-gray-60"
      style="right: -10px;top: -10px;" />
      <IconErrorTag :isError="isError" :required="false" :model="model" />
  </div>
  <ErrorTag :isError="isError" :model="model" :required="false" :errorMessage="errorMessage"  />
</template>
<script setup lang="ts">
import { computed, ref, useAttrs } from 'vue'
import { XMarkIcon, ExclamationCircleIcon } from '@heroicons/vue/24/outline'
import { getIsError } from '@/modules/Core/usings/generales';
type ModelValue = string | null
const attrs = useAttrs()
const model = defineModel<ModelValue>()
const props = defineProps<{
  label?: string
  clear?: boolean
  clearEvent?: Function
  error?: string | Array<any> | null | undefined
}>()
const errorMessage = ref<string | Array<any> | null>(null)
const isError = computed(() => {
  const isArray = Array.isArray(props.error)
  errorMessage.value = props.error || null
  return getIsError(props, isArray)
});
</script>
